import '@sass/common/theme.scss';
import CwLoadModules from '@customjs/module-loader.js';
import CwThemeFramework from '@customjs/generalFns.js';
import { MatchHeight } from 'js-match-height';


/**
 * Running mixed functions across the theme
 */
CwThemeFramework.generalFns();

/**
 * Bootstrap Tabs
 */
const tabs = document.querySelector('[role="tablist"]');

if (tabs) CwLoadModules.Tabs();

/**
 * Dropdown
 */
const dropdown = document.querySelector('.dropdown-toggle');

if (dropdown) CwLoadModules.Dropdown();

/**
 * Accordions
 */
const accordion = document.querySelector('.accordion');

if (accordion) CwLoadModules.Collapse();

/**
 * Service Worker
 */

// check if service worker is available

if ('serviceWorkerNO' in navigator) {
  document.addEventListener('DOMContentLoaded', () => {
    // Registering Service Worker
    navigator.serviceWorker
      // eslint-disable-next-line no-undef
      .register(`${ThemeURLS.childThemeURL}/sw.php`, {
				scope: '/',
			})
      .then((reg) => console.log(reg.scope))
      .catch((error) => console.log(error.message));
  });
}

/**
 * Loading Mobile Menu
 */

function matchMobile() {
  const mobileMediaQuery = window.matchMedia('(max-width: 1200px)');
  return mobileMediaQuery.matches;
}

matchMobile() ? CwThemeFramework.mobileMenu() : '';

window.addEventListener('resize', () => {
  //matchMobile() ? CwThemeFramework.mobileMenu() : '';
});

/**
 * Loading Modals in the Page
 * We will be pulling all the buttons with the data-cw-target
 * Attribute in order to initialize all the modals.
 */

// Checking for all out buttons
const modals = document.querySelectorAll('[data-cw-target]');
if (modals.length) {
  const modalInstances = [];
  CwLoadModules.modals().then((CwModals) => {
    modals.forEach((modalBtn, index) => {
      modalInstances[index] = new CwModals('.cw-modal');
      modalInstances[index].init();
    });
  });
}

/**
 * Table of Contents
 *
 */


/**
 * Loading Swiper JS
 * https://swiperjs.com/
 */
const carouselModules = {
  'checklist-slider-home': 'checklist-carousel',
  'results-slider-home': 'results-carousel-home',
  'results-slider': 'results-carousel',
  'results-slider__sidebar': 'results-slider-sidebar',
  'awards-wrap': 'awards-carousel',
  'awards-wrap-sidebar': 'awards-carousel-sidebar',
  'testimonials-section-slider': 'testimonials-carousel',
  'testimonials-section-slider-sidebar': 'testimonials-carousel-sidebar',
  'grid-attorney': 'team-carousel',
  'grid-videos': 'videos-carousel',
  'our-team': 'team-sidebar-widget',
};

// eslint-disable-next-line no-restricted-syntax
for (const [key, value] of Object.entries(carouselModules)) {
  const name = document.getElementById(key);
  if (name) {
    CwLoadModules.swiperSliders(value).then((module) => {
      module.default();
    });
  }
}

/**
 * Loading MatchHeight
 * Create new instance of MatchHeight [new MatchHeight()]
 * for elements that need to have the same height
 * https://www.npmjs.com/package/js-match-height
 */

const testimonialItem = new MatchHeight('.testimonials-section__item');
const whychooseusItem = new MatchHeight('.why-choose-us__item');
const attyItem = new MatchHeight('.attorney-item .info');

/**
 * Smooth Scroll
 * add class '.scroll' to new elements
 * class '.scroll' already added to footer back to top and TOC dynamic link elements
 */
// smooth scroll
document.addEventListener(
  'click',
  (event) => {
    if (!event.target.closest('.scroll')) return;

    const hashValue = event.target.closest('.scroll').getAttribute('href');
    const target = document.querySelector(hashValue);

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
    history.pushState(null, null, hashValue);
    event.preventDefault();
  },
  false
);

/**
 * Load More
 */
 const loadMore = null || document.querySelector('.load-more');
 const categoryFilter = null || document.querySelector('.cw-filter');
 
 if (loadMore || categoryFilter) {
   const enablePagination = loadMore.dataset.pagination;
 
   CwLoadModules.AjaxCalls().then((cwAjaxLib) => {
     const ajaxCalls = new cwAjaxLib({
       enablePagination: enablePagination,
     });
     ajaxCalls.init();
     if (categoryFilter) ajaxCalls.filter(categoryFilter);
     
   });
 }

// back to top
document.querySelectorAll('.btn-back').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});

// jQuery(document).ready(function() {
  
// 	var check_for_lightbox_links=function(a){jQuery(".cw_video_open_popup, .cw_video_open_popup_customized").each(function(){var b=jQuery(this);if(a)var c=a;else var c=b.attr("video_type");var d=b.attr("video_id"),e=b.attr("video_height")?b.attr("video_height"):400,f=b.attr("video_width")?b.attr("video_width"):600;video_showinfo=b.attr("video_showinfo"),video_rel=b.attr("video_rel"),video_autoplay=b.attr("video_autoplay")?b.attr("video_autoplay"):1;var g=!1,h=jQuery(window).width();if(h<=700||h<=f){var i=.85;f=i*h,f=Math.round(f),i=.565,e=f*i,e=Math.round(e)}switch(c){case"youtube":jQuery(this).attr("href","https://www.youtube.com/embed/"+d+"?rel="+video_rel+"&amp;showinfo="+video_showinfo+"&amp;autoplay="+video_autoplay+"&mute=1"),jQuery(this).colorbox({iframe:!0,innerWidth:f,innerHeight:e});break;case"vimeo":jQuery(this).attr("href","https://player.vimeo.com/video/"+d+"?title="+video_showinfo+"&amp;byline="+video_showinfo+"&amp;autoplay="+video_autoplay+"&amp;portrait=0&amp;color=333"),jQuery(this).colorbox({iframe:!0,innerWidth:f,innerHeight:e});break;default:g=!0,jQuery(this).attr("href","https://fast.wistia.net/embed/iframe/"+d),jQuery(this).colorbox({iframe:!0,innerWidth:f,innerHeight:e})}})};
// 	check_for_lightbox_links();
// });

/// Legal Services Tab
const elements = document.getElementsByClassName("pa-list-menu");
for (var i = 0; i < elements.length; i++) {
  
  elements[i].addEventListener('click',  function() {
    var selected_title = this.getAttribute('data-title');
    var list = document.getElementsByClassName("pa-list");
    for (var x = 0; x < list.length; x++) {
      list[x].classList.add("d-none");
    }


    var selected_list = document.getElementsByClassName("pa-list-"+selected_title);
    for (var y = 0; y < selected_list.length; y++) {
      selected_list[y].classList.remove("d-none");
    }


    var menu_list = document.getElementsByClassName("pa-list-menu");
    for (var o = 0; o < menu_list.length; o++) {
      menu_list[o].classList.remove("active-selection");
    }

    this.classList.add("active-selection");
  }, false);


}

const elements2 = document.getElementById("pa-dropdown");
if(elements2){
elements2.addEventListener('change',  function() {
  var selected_title = this.value;
  var list = document.getElementsByClassName("pa-list");
  for (var x = 0; x < list.length; x++) {
    list[x].classList.add("d-none");
  }


  var selected_list = document.getElementsByClassName("pa-list-"+selected_title);
  for (var y = 0; y < selected_list.length; y++) {
    selected_list[y].classList.remove("d-none");
  }


  var menu_list = document.getElementsByClassName("pa-list-menu");
  for (var o = 0; o < menu_list.length; o++) {
    menu_list[o].classList.remove("active-selection");
  }

  
}, false);
}

/**
 * Practice area types carousel (#myCarousel)
 * Handles prev/next, indicator clicks, auto-slide and slide transition.
 */
function initPracticeAreaCarousel() {
  const carousel = document.getElementById('myCarousel');
  if (!carousel) return;

  const inner = carousel.querySelector('.carousel-inner');
  const items = carousel.querySelectorAll('.carousel-inner .item');
  const indicators = carousel.querySelectorAll('.carousel-indicators > div');
  const prevBtn = carousel.querySelector('.carousel-control[data-slide="prev"]');
  const nextBtn = carousel.querySelector('.carousel-control[data-slide="next"]');

  if (!inner || !items.length) return;

  const total = items.length;
  let currentIndex = 0;
  const AUTO_SLIDE_INTERVAL = 4000;
  let autoSlideTimer = null;

  carousel.style.setProperty('--carousel-total', total);

  function goToSlide(index) {
    if (index < 0) index = total - 1;
    if (index >= total) index = 0;
    currentIndex = index;

    inner.style.transform = `translateX(-${currentIndex * (100 / total)}%)`;
    items.forEach((item, i) => item.classList.toggle('active', i === currentIndex));
    indicators.forEach((ind, i) => ind.classList.toggle('active', i === currentIndex));
  }

  function startAutoSlide() {
    stopAutoSlide();
    autoSlideTimer = setInterval(() => goToSlide(currentIndex + 1), AUTO_SLIDE_INTERVAL);
  }

  function stopAutoSlide() {
    if (autoSlideTimer) {
      clearInterval(autoSlideTimer);
      autoSlideTimer = null;
    }
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      goToSlide(currentIndex - 1);
      startAutoSlide();
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      goToSlide(currentIndex + 1);
      startAutoSlide();
    });
  }

  indicators.forEach((indicator, index) => {
    indicator.addEventListener('click', (e) => {
      e.preventDefault();
      goToSlide(index);
      startAutoSlide();
    });
  });

  carousel.addEventListener('mouseenter', stopAutoSlide);
  carousel.addEventListener('mouseleave', startAutoSlide);

  goToSlide(0);
  startAutoSlide();
}

document.addEventListener('DOMContentLoaded', initPracticeAreaCarousel);

/**
 * Results descriptions: expand/collapse remaining sentences
 * and keep homepage result cards the same height.
 */
function updateResultsSwiper(grid) {
  if (grid && grid.swiper) {
    grid.swiper.updateAutoHeight();
    grid.swiper.update();
  }
}

function equalizeGridResultsHeights(grid) {
  if (!grid) return;

  const items = grid.querySelectorAll('.item');
  items.forEach((item) => {
    item.style.height = '';
  });

  const hasExpanded = grid.querySelector('.results-content__toggle[aria-expanded="true"]');
  const isStacked = window.matchMedia('(max-width: 767px)').matches;

  if (!hasExpanded || isStacked) {
    updateResultsSwiper(grid);
    return;
  }

  requestAnimationFrame(() => {
    let maxHeight = 0;
    items.forEach((item) => {
      maxHeight = Math.max(maxHeight, item.offsetHeight);
    });

    items.forEach((item) => {
      item.style.height = `${Math.ceil(maxHeight)}px`;
    });

    updateResultsSwiper(grid);
  });
}

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('.results-content__toggle');
  if (!toggle) return;

  event.preventDefault();
  event.stopPropagation();

  const container = toggle.closest('.results-content');
  const more = container ? container.querySelector('.results-content__more') : null;
  const expanded = toggle.getAttribute('aria-expanded') === 'true';

  toggle.setAttribute('aria-expanded', String(!expanded));
  toggle.textContent = expanded
    ? toggle.dataset.more || 'Read more'
    : toggle.dataset.less || 'Read less';

  if (more) {
    more.hidden = expanded;
  }

  equalizeGridResultsHeights(toggle.closest('.grid-results'));
});

window.addEventListener('resize', () => {
  document.querySelectorAll('.grid-results').forEach((grid) => {
    if (grid.querySelector('.results-content__toggle[aria-expanded="true"]')) {
      equalizeGridResultsHeights(grid);
    }
  });
});
///